import React, { useState, useRef, useEffect, useCallback } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import B2BLayout from '../../../../layouts/b2b'
import fetchAPI from '../../../../../lib/utils/fetch-api'
import { DefaultJsonForm } from '../../../../components/v2/default-json-form'
import { Alert, Skeleton, Button } from 'antd'
import { SaveOutlined } from '@ant-design/icons'
import { MapContent, MapTitle, MapWrapper, AlertWrapper, TaskWrapper } from './styles'
import { schema } from './schema'
import { objectToUrl, renameKeys, setEnumFields } from '../../../utils'
import './index.css'

const breadcrumbs = [
  {
    href: '/admin',
    title: 'Админка',
  },
  {
    href: '/hr/payments',
    title: 'Список оплат',
  },
]

export default function AdminNewObjectPage() {
  const { id } = useParams() as any
  const navigate = useNavigate()
  const [isDataLoading, setIsDataLoading] = useState<boolean>(true)
  const [pageErrors, setPageErrors] = useState<string[]>([])
  const [pageSuccess, setPageSuccess] = useState<string[]>([])
  const formDataRef = useRef<any>({})
  const [matchedJSONSchema, setMatchedJSONSchema] = useState<any>(null)
  const [formData, setFormData] = useState<any>({})

  const saveCase = useCallback(async () => {
    console.log({
      ref: formDataRef.current,
      formData,
    })
    await fetchAPI(`/api/hr/payments/${id}`, {
      method: 'POST',
      body: JSON.stringify(formData),
    }).then(result => {
      if (result?.error) {
        const errors =
          Array.isArray(result['errors']) && result['errors']?.length > 0
            ? result['errors'].map(error => error['detail'])
            : ['Неизвестная ошибка при выполнении запроса']
        setPageSuccess([])
        setPageErrors(errors)
      } else {
        navigate(`/hr/payments`)
      }
    })
  }, [history, id, formData])

  const getData = useCallback(async () => {
    {
      if (id !== 'new') {
        const data = await fetchAPI(`/api/hr/payments/${id}`)
        const formData = data.reduce((obj, cur) => ({ ...obj, [cur.name]: cur.value }), {})
        formDataRef.current = { ...formData }
      }

      const enumsList = { types: ['hr_resource'] }
      const enums = await fetchAPI(`/api/enum-list${objectToUrl(enumsList)}`)
      const fixKeys = renameKeys(enums, { hr_resource: 'resource_id' })

      setEnumFields(fixKeys, schema)
      setMatchedJSONSchema(schema)
    }
    setPageErrors([])
    setIsDataLoading(false)
  }, [id, setFormData])

  useEffect(() => {
    getData().catch(e => {
      console.error({ e })
    })
  }, [getData])

  const onFormData = useCallback(
    ({ formData }) => {
      setFormData(formData)
    },
    [setFormData],
  )

  return (
    <B2BLayout breadcrumbs={breadcrumbs}>
      <MapWrapper>
        <TaskWrapper>
          <MapTitle>
            {id === 'new' ? (
              <>Добавление оплаты</>
            ) : (
              <>
                Оплата <span>{formDataRef.current?.name}</span>
              </>
            )}
          </MapTitle>
        </TaskWrapper>
        <MapContent>
          {pageErrors.length > 0 ? (
            <AlertWrapper>
              <Alert
                message="При выполнении операции возникла ошибка:"
                showIcon
                type="error"
                description={pageErrors.join('. ')}
              />
            </AlertWrapper>
          ) : null}
          {pageSuccess.length > 0 ? (
            <div style={{ marginBottom: 40 }}>
              <Alert message={pageSuccess.join('. ')} showIcon type="success" />
            </div>
          ) : null}
          {!isDataLoading ? (
            <>
              <DefaultJsonForm
                formData={formDataRef.current}
                schema={matchedJSONSchema}
                onChange={onFormData}
                orientation="vertical"
              />
              <Button onClick={saveCase} style={{ marginBottom: 16, marginTop: 16 }} type="primary">
                <SaveOutlined />
                Сохранить
              </Button>
            </>
          ) : (
            <Skeleton active />
          )}
        </MapContent>
      </MapWrapper>
    </B2BLayout>
  )
}
